import './Footer.scss';
import Link from '../Link/Link';

function Footer(): React.JSX.Element {
  return (
    <footer className='footer'>
      <ul className='footer__links-list'>
        <li>
          <Link
            className='footer__link'
            href='https://www.newcastlepermanent.com.au/security-advice'
          >
            Security Advice
          </Link>
          <span className='divider'>|</span>
        </li>
        <li>
          <Link
            className='footer__link'
            href='https://www.newcastlepermanent.com.au/privacy-policy'
          >
            Privacy Policy
          </Link>
          <span className='divider'>|</span>
        </li>
        <li>
          <Link
            className='footer__link'
            href='https://www.newcastlepermanent.com.au/terms-of-use'
          >
            Terms of Use
          </Link>
        </li>
      </ul>

      <div className='footer__legal-info'>
        <p>
          <Link
            className='footer__link -npbs'
            href='https://www.newcastlepermanent.com.au/'
          >
            Newcastle Permanent
          </Link>
          ,&nbsp;part of Newcastle Greater Mutual Group Ltd
        </p>

        <p>
          ACN 087 651 992 Australian Financial Services Licence/Australian
          credit licence 238273
        </p>
      </div>
      <div className='footer__disclaimer-info'>
        <p>
          General Advice Warning: Any general advice on this website (including
          via webchat) has been prepared without taking into account your
          objectives, financial situation or needs. Therefore, before acting on
          the advice, you should consider its appropriateness (having regard to
          your personal circumstances). Before deciding to acquire a financial
          product from us, you should also consider the relevant&nbsp;
          <Link
            className='footer__link'
            href='https://www.newcastlepermanent.com.au/tools-and-services/terms-and-conditions'
          >
            Terms and Conditions
          </Link>
          &nbsp;or Product Disclosure Statement.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
